import { useEffect, useState } from 'react';
import { mutateConfig } from '../../../../api/queryBase';
import { OnboardingDocument } from '../../../../interfaces/Onboarding';
import { getErrorMessage, openNotification } from '../../../../utils/helper';
import { DocumentUploader } from '../../../DocumentUploader';
import { SuitUIButton } from '../../../SuitUIButton';

export const UploadDocuments = ({
    onboardingDocuments,
    refetchUser,
    refetchOnbordingDocuments
}: {
    onboardingDocuments: OnboardingDocument[];
    refetchUser: () => void;
    refetchOnbordingDocuments: () => void;
}) => {
    const mutation = mutateConfig({ method: 'post' });
    const { mutate, isLoading: uploading } = mutation<{ fileUri: string }>({
        url: `/corporates/onboarding/upload`
    });

    const [documentList, setDocumentList] =
        useState<OnboardingDocument[]>(onboardingDocuments);

    useEffect(() => {
        setDocumentList(onboardingDocuments);
    }, [onboardingDocuments]);

    const handleUpdateDocumentList = ({
        itemId,
        url
    }: {
        itemId: number;
        url: string;
    }) => {
        setDocumentList(
            documentList.map((document) =>
                document.itemId === itemId
                    ? { ...document, documentUrl: url }
                    : document
            )
        );
    };

    const handleMutation = (data: {
        documentItemId: number;
        documentUrl: string;
    }) => {
        mutate(data, {
            onSettled: (_, error) => {
                if (error) {
                    openNotification(
                        'error',
                        getErrorMessage(error) || 'An error occurred'
                    );
                    return;
                } else {
                    refetchUser();
                    refetchOnbordingDocuments();
                }
            }
        });
    };
    const handleSubmit = () => {
        documentList.map((item) => {
            handleMutation({
                documentItemId: item.itemId,
                documentUrl: item.documentUrl
            });
        });
    };

    return (
        <div className='flex flex-col pt-[80px] items-center'>
            <div className='w-full max-w-[352px] '>
                <p className='font-semibold text-ebony text-lg'>
                    Upload document
                </p>
                <p className='text-sm text-midnightHaze max-w-[352px]  mb-6'>
                    Kindly proceed to add your business documents.
                </p>

                {documentList?.map((item: OnboardingDocument, index) => (
                    <DocumentUploader
                        useAuthorization
                        key={`upload-doc-${item.documentId}-${index}`}
                        title={item.documentName}
                        runAfterUpload={true}
                        documentItemId={item.itemId}
                        uploaded={item.uploaded}
                        documentUrl={item.documentUrl}
                        status={item.status}
                        onUpload={(url: string) =>
                            handleUpdateDocumentList({
                                itemId: item.itemId,
                                url
                            })
                        }
                        rejectedMessage={item.rejectedMessage}
                    />
                ))}

                <SuitUIButton
                    text='Submit'
                    fullWidth
                    onClick={handleSubmit}
                    isLoading={uploading}
                />
            </div>
        </div>
    );
};
